import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { EDIT_PROFILE, GET_PROFILE, CLOSE_ACCOUNT } from "./actionTypes"
import { profileSuccess, profileError, closeAccount } from "./actions"

//Include Both Helper File with needed methods
import {
  postJwtUpdateProfile,
  getJwtProfile,
  postJwtCloseAccount,
} from "../../../helpers/auth_helper"

function* getProfile({ payload: { userId } }) {
  try {
    const response = yield call(getJwtProfile, {
      idx: userId,
    })
    if(response?.data) {
      yield put(profileSuccess({data: response.data, message: "Loaded successfully"}));
    } else if(response?.error) {
      yield put(profileError(response.error.message[0]));
    }
  } catch (error) {
    yield put(profileError(error))
  }
}

function* editProfile({ payload: { user } }) {
  try {
    const {userName, fullName, email, phoneNumber, id, role, enabled} = user;
    const response = yield call(postJwtUpdateProfile, {userName, fullName, email, phoneNumber: phoneNumber==='' ? null : phoneNumber, id, role, enabled})
    if(response.error === null) {
      yield put(profileSuccess({data: user, message: 'Updated successfully'}));
    } else if(response?.error) {
      yield put(profileError(response.error.message[0]));
    }
  } catch (error) {
    yield put(profileError(error))
  }
}

function* removeAccount() {
  try {
    const response = yield call(postJwtCloseAccount, {});
    if(response.error === null) {
      yield put(profileSuccess({data: {}, message: 'Closed successfully'}));
    } else if(response?.error) {
      yield put(profileError(response.error.message[0]));
    }
  } catch(error) {
    yield put(profileError(error));
  }
}

export function* watchProfile() {
  yield takeEvery(GET_PROFILE, getProfile)
  yield takeEvery(EDIT_PROFILE, editProfile)
  yield takeEvery(CLOSE_ACCOUNT, removeAccount)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
